const GET_CREATE_NEW_CODE_LIST = 'GET_CREATE_NEW_CODE_LIST';
const SET_CREATE_NEW_CODE_LIST = 'SET_CREATE_NEW_CODE_LIST';

const GET_CREATE_NEW_CODE_SAVE = 'GET_CREATE_NEW_CODE_SAVE';
const SET_CREATE_NEW_CODE_SAVE = 'SET_CREATE_NEW_CODE_SAVE';

export
{
    GET_CREATE_NEW_CODE_LIST,
    SET_CREATE_NEW_CODE_LIST,
    GET_CREATE_NEW_CODE_SAVE,
    SET_CREATE_NEW_CODE_SAVE
};